import { createSlice } from "@reduxjs/toolkit";

import CookiesManager from "../../common/utils/cookies";

const initialState = {
  isAuth: false,
  username: "",
  id_token: "",
  access_token: "",
  refresh_token: "",
  role: "",
};

const { setCookie, removeCookie } = CookiesManager;

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state, action) => {
      state.isAuth = false;
      state.username = "";
      state.role = "";
      state.id_token = "";
      state.access_token = "";
      state.refresh_token = "";
      removeCookie("userData");
    },
    setUser: (state, action) => {
      const {
       username = "user",
       role = "",
       access_token,
       id_token,
       refresh_token,
      } = action.payload;
      if (!!role && !!access_token && !!refresh_token) {        
        state.isAuth = true;
        state.username = username;
        state.role = role;
        state.id_token = id_token;
        state.access_token = access_token;
        state.refresh_token = refresh_token;

        setCookie({userData: { id_token, access_token, refresh_token, role }});
      }
    },
    restoreFromCookie: (state, action) => {
      const { access_token, id_token, refresh_token, role } = action.payload;
      state.username = "user" ;
      state.role = role;
      state.isAuth = true;
      state.id_token = id_token;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
    },
    refreshTokens: (state, action) => {
      const { access_token, id_token, refresh_token } = action.payload;
      state.id_token = id_token;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
      // removeCookie("userData");
      setCookie({ userData: { id_token, access_token, refresh_token, role: state.role }});
    },
  },
});

export const { setUser, refreshTokens, logout, restoreFromCookie } = loginSlice.actions;

export const selectUser = (state) => state.loginReducer;
export const selectIsAuth = (state) => state.loginReducer.isAuth;
export const selectUsername = (state) => state.loginReducer.username;
export const selectRefreshToken = (state) => state.loginReducer.refresh_token;

export const selectRole = (state) => state.loginReducer.role;

export default loginSlice.reducer;
